import React from 'react';
import AntCondition from '../../utils/AntCondition';
import '../AntWidgetSkeleton/index.scss';
import './index.scss';

function times(n) {
    return Array.from({ length: Math.max(n | 0, 0) }, function (_, i) {
        return i;
    });
}

// Lấy kích thước thẻ đúng theo cấu hình cardLayout.sizing (cùng cách AntPOSCardViewCell dùng).
function resolveSizing(cardLayout) {
    if (!cardLayout || cardLayout.sizing instanceof Array === false) return {};
    for (var i = 0; i < cardLayout.sizing.length; i++) {
        var s = cardLayout.sizing[i];
        if (s.when && typeof s.when === 'object') {
            if (AntCondition.isValid(null, { when: s.when, whenType: s.whenType })) return s.value || {};
        } else return s.value || {};
    }
    return {};
}

// Số cột: ưu tiên cấu hình colCount, không có thì suy từ tên lớp dạng "...-5col".
function resolveColumns(props) {
    if (props.colCount > 0) return props.colCount;

    var text = '';
    var cls = props.cardClasses;
    if (typeof cls === 'string') text = cls;
    else if (cls instanceof Array) {
        for (var i = 0; i < cls.length; i++) {
            var c = cls[i];
            if (typeof c === 'string') {
                text = c;
                break;
            }
            if (c && c.value) {
                if (!c.when || AntCondition.isValid(null, { when: c.when, whenType: c.whenType })) {
                    text = String(c.value);
                    break;
                }
            }
        }
    }

    var m = /-(\d+)col(\s|$)/.exec(text || '');
    if (m) return parseInt(m[1], 10);
    return 5;
}

/**
 * Lớp phủ xám tượng trưng cho một danh sách thẻ trong lúc chờ máy chủ trả dữ liệu
 * lần đầu. Giữ đúng số cột và chiều cao thẻ theo cấu hình để bố cục không xê dịch.
 */
export default function AntCardListSkeleton(props) {
    var size = resolveSizing(props.cardLayout);
    var cols = Math.min(Math.max(resolveColumns(props), 1), 12);
    var height = size.minCellHeight || props.cellHeight || 100;
    var count = props.count || cols * 3;
    var basis = 100 / cols + '%';

    return (
        <div className="ant-card-skeleton-list" aria-hidden="true">
            {times(count).map(function (i) {
                return (
                    <div key={i} className="ant-card-skeleton-slot" style={{ flexBasis: basis, maxWidth: basis }}>
                        <div className="ant-card-skeleton" style={{ minHeight: height, height: height }}>
                            <span className="ant-sk ant-card-skeleton__title" />
                            <span className="ant-sk ant-card-skeleton__line" />
                            <span className="ant-sk ant-card-skeleton__chip" />
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
